import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { StorageProvider } from './hoc/LocalStorage';
import { NotificationsProvider } from "./hoc/NotificationsContext";

import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <StorageProvider>
        <NotificationsProvider>
            <App />
        </NotificationsProvider>
    </StorageProvider>
);

reportWebVitals();

serviceWorkerRegistration.register();